"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchResultsSectionHeaderMessage = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
/**
 * @copyright
 * Copyright (c) 2022 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */
// For some reason we used injectSheet for the RefreshButton
var IconButton_1 = __importDefault(require("@atg/icf-react-components/components/IconButton"));
var Text_1 = __importDefault(require("@atg/icf-react-components/components/Text"));
var react_jss_1 = require("react-jss");
var HiddenText_1 = require("./HiddenText");
var useSearchResultsSectionHeaderMessageStyles = (0, react_jss_1.createUseStyles)(function (theme) { return ({
    headerMessage: function (_a) {
        var isLarge = _a.isLarge;
        return (__assign(__assign({ fontSize: isLarge ? 22 : 16 }, (!isLarge && { marginBottom: "4px" })), { hyphens: "auto", lineHeight: isLarge ? 1.45 : 1.3, display: "flex", justifyContent: "center", minWidth: 0, columnGap: theme.spacing.base / 2 }));
    },
    carrotWrap: {
        transform: "scaleX(1.5) scaleY(0.7)",
    },
    headerCaret: {
        fontStyle: "normal",
        fontSize: "10px",
        marginInlineStart: "4px",
    },
    noWrap: {
        whiteSpace: "nowrap",
    },
    modelCount: {
        display: "inline-block",
    },
    totalPerformers: {
        marginInlineStart: theme.spacing.base * 2,
        display: "inline-block",
        fontSize: theme.spacing.base * 2,
        color: theme.colors.baseContrast050,
        "&:hover": {
            cursor: function (_a) {
                var isFirstHeader = _a.isFirstHeader;
                return (isFirstHeader ? "inherit" : "pointer");
            },
        },
    },
    messageWrapper: {
        display: "flex",
        alignItems: "center",
        overflow: "hidden",
        whiteSpace: "nowrap",
        textOverflow: "ellipsis",
        flexShrink: 1,
    },
}); });
var SearchResultsSectionHeaderMessage = function (_a) {
    var className = _a.className, emitTrackingEvent = _a.emitTrackingEvent, isFirstHeader = _a.isFirstHeader, isLarge = _a.isLarge, message = _a.message, onRefreshClicked = _a.onRefreshClicked, onMessageClicked = _a.onMessageClicked, totalPerformersText = _a.totalPerformersText, blur = _a.blur;
    var classes = useSearchResultsSectionHeaderMessageStyles({
        isLarge: isLarge,
        isFirstHeader: isFirstHeader,
    });
    return ((0, jsx_runtime_1.jsxs)("div", { "data-ta-locator": "SearchResults-message", className: "".concat(classes.headerMessage, " ").concat(className !== null && className !== void 0 ? className : ""), onClick: isLarge ? undefined : onMessageClicked, children: [isLarge ? ((0, jsx_runtime_1.jsx)("div", { className: classes.messageWrapper, children: blur ? (0, jsx_runtime_1.jsx)(HiddenText_1.HiddenText, { text: message, width: "4rem" }) : message })) : ((0, jsx_runtime_1.jsx)(Text_1.default, { "data-ta-locator": "SearchResults-OverFilteredMessage", color: "baseContrast060", margin: "0 0 4 0", children: blur ? (0, jsx_runtime_1.jsx)(HiddenText_1.HiddenText, { text: message, width: "4rem" }) : message })), isLarge && ((0, jsx_runtime_1.jsxs)("div", { className: classes.noWrap, children: [totalPerformersText && ((0, jsx_runtime_1.jsx)("div", { className: classes.modelCount, children: (0, jsx_runtime_1.jsx)("a", { href: isFirstHeader ? undefined : "/", children: (0, jsx_runtime_1.jsx)("div", { className: classes.totalPerformers, "data-ta-locator": "SearchResults-count", children: totalPerformersText }) }) })), (0, jsx_runtime_1.jsx)(IconButton_1.default, { size: 20, buttonHeight: 20, buttonWidth: 20, name: "refresh", fill: "primary", onClick: function () {
                            onRefreshClicked();
                            emitTrackingEvent("icfClick", "refreshGrid", "");
                        }, "data-ta-locator": "SearchResultsSectionHeader-IconButton-RefreshGrid" })] }))] }));
};
exports.SearchResultsSectionHeaderMessage = SearchResultsSectionHeaderMessage;
exports.SearchResultsSectionHeaderMessage.displayName = "SearchResultsSectionHeaderMessage";
//# sourceMappingURL=SearchResultsSectionHeaderMessage.js.map